import { render, staticRenderFns } from "./AddDemoAccount.vue?vue&type=template&id=72aac37f"
import script from "./AddDemoAccount.vue?vue&type=script&lang=js"
export * from "./AddDemoAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports